import type { CollectedDataOption, OnboardingRequirementCollectData } from '@onefootprint/request-types';

export const getAllAttributes = (req: OnboardingRequirementCollectData): CollectedDataOption[] => [
  ...req.missingAttributes,
  ...req.populatedAttributes,
  ...req.optionalAttributes,
];
